import {Box, Grid, Stack, IconButton, Typography, Button} from "@mui/material";
import {IconBrandFacebook, IconBrandLinkedin} from "@tabler/icons-react";

export const LandingFooter = () => {

  return (
    <Grid container spacing={{xs: 2, md: 6}} justifyContent={"center"}
          sx={{minHeight: "25dvh", bgcolor: "primary.dark", px: {xs: 2, md: 6}, py: {xs: 4, md: 10}}}>
      <Grid item sx={{maxWidth: "420px", width: "90%"}}>
        <Stack direction={"row"} gap={1} alignItems={"center"} sx={{pb: 3}}>
          <Box sx={{maxWidth: {xs: 70, md: 90}}}>
            <img src={"/logo_white.svg"} alt={"logo"} width="100%" height="auto"/>
          </Box>
          <Typography fontSize={{xs: "1em", md: "2em"}} color={"#fefefe"}>OpenBrain</Typography>
        </Stack>
        <Typography fontSize={{xs: "0.9em"}} fontStyle={"italic"} color={"#fefefe"}>The Smarter Way to Handle
          Calls</Typography>
      </Grid>
      <Grid item sx={{maxWidth: "420px", width: "90%", display: "flex", flexDirection: "column", gap: 1}}>
        <Typography fontSize={{xs: "1em"}} fontWeight={600} color={"#fefefe"} sx={{pb: 1}}>Contact Information</Typography>
        <Typography fontSize={{xs: "0.9em"}} color={"#fefefe"}>3rd Macedonian Brigade 37, Skopje</Typography>
        <Typography fontSize={{xs: "0.9em"}} component={"a"} href="tel:+38975753932" color={"#fefefe"}>+389 75 753
          932</Typography>
        <Typography fontSize={{xs: "0.9em"}} component={"a"} href="mailto:contact@ireason.mk"
                    color={"#fefefe"}>contact@ireason.mk</Typography>

      </Grid>
      <Grid item sx={{maxWidth: "240px", width: "90%", display: "flex", flexDirection: "column", gap: 2}}>
        <Typography fontSize={{xs: "1em"}} fontWeight={600} color={"#fefefe"}>Community</Typography>
        <Box>
          <Button color={"light"} size={"large"} sx={{p: 0}} startIcon={<IconBrandFacebook size={24}/>} component={"a"}
                  href={"https://www.facebook.com/ireasonmk"} target={"_blank"}>
            Facebook
          </Button>
        </Box>
        <Box>
          <Button color={"light"} size={"large"} sx={{p: 0}} startIcon={<IconBrandLinkedin size={24}/>} component={"a"}
                  href={"https://www.linkedin.com/company/ireason/"} target={"_blank"}>
            LinkedIn
          </Button>
        </Box>
      </Grid>
    </Grid>
  )
}